var map = {
	"./bank-transfer.svg": 829,
	"./betnearn-ico.svg": 830,
	"./birthday-bonus-ico.svg": 831,
	"./birthday.svg": 832,
	"./bonus-code-ico.svg": 833,
	"./bonus-ico.svg": 834,
	"./bonus-received-ico.svg": 835,
	"./bonus.svg": 836,
	"./business-account-upgrade-ico.svg": 837,
	"./check-in-daily-ico.svg": 838,
	"./checked.svg": 839,
	"./cloud-pointer.svg": 840,
	"./coin.svg": 841,
	"./crypto.svg": 842,
	"./daily-bonus-ico.svg": 843,
	"./daily-limit.svg": 844,
	"./deposit-delay-bonus-ico.svg": 845,
	"./e-wallet.svg": 846,
	"./earn-x33-coin-ico.svg": 847,
	"./email.svg": 848,
	"./facebook.svg": 849,
	"./feedback.svg": 850,
	"./first-bet-ico.svg": 851,
	"./games-rebate-ico.svg": 852,
	"./info.svg": 853,
	"./instagram.svg": 854,
	"./instant-rebate.svg": 855,
	"./live-casino-rebate-ico.svg": 856,
	"./lucky-spin-ico.svg": 857,
	"./messenger.svg": 858,
	"./mobile-app-deposit-ico.svg": 859,
	"./monthly-cash.svg": 860,
	"./msg-activity.svg": 861,
	"./msg-ann.svg": 862,
	"./msg-notice.svg": 863,
	"./new-icon.svg": 864,
	"./people-ico.svg": 865,
	"./quick-pay.svg": 866,
	"./rescue-bonus-ico.svg": 867,
	"./rescue-lc-ico.svg": 868,
	"./rescue-slots-ico.svg": 869,
	"./return.svg": 870,
	"./sc-bc-active-ico.svg": 871,
	"./sc-bc-ico.svg": 872,
	"./sc-bi-active-ico.svg": 873,
	"./sc-bi-ico.svg": 874,
	"./sc-mail-active-ico.svg": 875,
	"./sc-mail-ico.svg": 876,
	"./sc-mp-active-ico.svg": 877,
	"./sc-mp-ico.svg": 878,
	"./sc-pin-active-ico.svg": 879,
	"./sc-pin-ico.svg": 880,
	"./slots-rebate-ico.svg": 881,
	"./sms.svg": 882,
	"./sports-rebate-ico.svg": 883,
	"./telegram.svg": 884,
	"./twitter.svg": 885,
	"./vip-up-level-ico.svg": 886,
	"./vip-weekly-bonus.svg": 887,
	"./wallet-balance-interest-ico.svg": 888,
	"./wallet-ico.svg": 889,
	"./weekly-tournament-ico.svg": 890,
	"./welcome-bonus-188-ico.svg": 891,
	"./welcome-bonus-ico.svg": 892,
	"./whatsapp-original.svg": 893,
	"./whatsapp.svg": 894,
	"./withdrawal-delay-bonus-ico.svg": 895,
	"./withdrawal.svg": 896,
	"./x33-coin.svg": 897
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 63;